class SectionEvent extends HTMLElement {
  constructor() {
    super();

    this.container = this;

    this.citySelect = this.container.querySelector('.js-event-filter-ville');
    this.establishSelect = this.container.querySelector('.js-event-filter-establish');
    this.dateInput = this.container.querySelector('.js-event-date-range');
    this.dateRange = [];

    if (this.citySelect || this.establishSelect || this.dateInput) {
      this.clearFilter = this.container.querySelector('.js-event-filter-all');
      this.items = this.container.querySelectorAll('.event-block');
      this.init();
    }
  }

  init() {
    if (this.dateInput) {
      this.date = flatpickr(this.dateInput, {
        mode: "range",
        dateFormat: "Y-m-d",
        onChange: (selectedDates) => {
          if (selectedDates.length === 2) {
            this.dateRange = selectedDates;
            this.update();
          }
        }
      });
    }

    if (this.citySelect) {
      this.citySelect.addEventListener('change', () => this.update());
    }

    if (this.establishSelect) {
      this.establishSelect.addEventListener('change', () => this.update());
    }
    
    if (this.clearFilter) {
      this.clearFilter.addEventListener('click', () => this.clear());
    }
  }

  update() {
    const city = this.citySelect ? this.citySelect.value : null;
    const establish = this.establishSelect ? this.establishSelect.value : null;
    const useDateRange = this.dateRange.length === 2;

    const activeFilters = [];
    if (city) activeFilters.push('city');
    if (establish) activeFilters.push('establish');
    if (useDateRange) activeFilters.push('date');

    this.items.forEach(item => {
      let matchCount = 0;
      if (city && item.dataset.city === city) matchCount++;
      if (establish && item.dataset.establish === establish) matchCount++;

      if (useDateRange) {
        const itemDate = item.dataset.date;
        if (itemDate) {
          const time = new Date(itemDate).getTime();

          const from = this.dateRange[0].getTime();

          const endOfDay = new Date(this.dateRange[1]);
          endOfDay.setHours(23, 59, 59, 999);
          const to = endOfDay.getTime();
          
          if (time >= from && time <= to) matchCount++;
        }
      }

      if (activeFilters.length === 0) {
        item.classList.remove('hidden');
      } else if (activeFilters.length === 1) {
        matchCount === 1 ? item.classList.remove('hidden') : item.classList.add('hidden');
      } else {
        matchCount > 0 ? item.classList.remove('hidden') : item.classList.add('hidden');
      }
    });
  }

  clear() {
    if (this.citySelect) {
      this.citySelect.value = this.citySelect.options[0].text;
    }

    if (this.establishSelect) {
      this.establishSelect.value = this.establishSelect.options[0].text;
    }

    if (this.dateInput) {
      this.date.clear();
    }

    this.items.forEach(item => {
      item.classList.remove('hidden');
    });
  }
}

customElements.define("section-event", SectionEvent);